import { Play } from "@phosphor-icons/react";
import type { FeaturePalette } from "@/shared/components/command-palette/types";

export const nbackPalette: FeaturePalette = {
  commands: [
    {
      id: "nback.start",
      title: "Start N-Back session",
      icon: Play,
      scopeId: "nback",
      keywords: ["nback", "working memory", "train"],
      run: (ctx) => ctx.router.push("/nback"),
    },
  ],
};
